import { NavLink } from 'react-router-dom';

import Tab from '@mui/material/Tab';

interface IStyledTabProps {
    disabled?: boolean;
    label: string | undefined;
    link: string;
    value?: string;
}

export const StyledTab = ({ link, ...rest }: IStyledTabProps) => {
    return (
        <Tab
            component={NavLink}
            to={link}
            sx={{
                textTransform: 'none',
                fontSize: '16px',
                fontFamily: 'Source Sans Pro',
                fontWeight: 'bold',
            }}
            {...rest}
        />
    );
};
